if (typeof complementaryProductsComponent === "undefined") {
  class ComplementaryProductsComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.buildProducts();
      $(this).css("opacity", "1");
    }

    buildProducts(url) {
      var swiper = new Swiper(".complementary-products-slider-swiper", {
        slidesPerView: 3,
        spaceBetween: 10,
        breakpoints: {
          320: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 2.6,
            spaceBetween: 10,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
      });
    }
  }

  customElements.define(
    "complementary-products",
    ComplementaryProductsComponent
  );

  var complementaryProductsComponent = ComplementaryProductsComponent;
}
